var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCallEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.949 12.993-.198 1.037c-.184.971-1.092 1.623-2.12 1.524l-2.047-.198c-.891-.086-1.651-.72-1.878-1.566l-.631-2.355c-.935-.383-1.965-.558-3.09-.526a8.102 8.102 0 0 0-3.14.708l-.392 2.205c-.148.836-.837 1.459-1.71 1.547l-2.035.204c-1.016.102-1.989-.544-2.277-1.51l-.31-1.038c-.308-1.031-.033-2.117.721-2.85 1.781-1.73 4.75-2.598 8.907-2.604 4.164-.005 7.225.857 9.185 2.588.825.728 1.21 1.806 1.015 2.834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallEnd);
export default __webpack_public_path__ + "static/media/ic-call-end.288bed975998ec45b72a086b412f5720.svg";
export { ForwardRef as ReactComponent };